import { isTeamsEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';

import { isAccessSummaryEnabled } from './isAccessSummaryEnabled';

export function isTeamAccessSummaryEnabled() {
  return isAccessSummaryEnabled() && isTeamsEnabled();
}
